import React from "react"
export default function Hero({ data }) {
  const { url, alt } = data?.allPrismicMainPage.edges[0].node.data.hero_image
  return (
    <div>
      <img
        className="hero-image"
        src={url}
        alt={alt}
      />
    </div>
  )
}
